import React from 'react'
import cn from 'classnames'

export default function Legends({ list, className }) {
  return (
    <div className={cn('flex rating-legends', className)}>
      {list.map(legend => (
        <span key={legend}>{legend}</span>
      ))}
    </div>
  )
}
